import { NavLink, useNavigate } from 'react-router-dom';
import { Home, Image, Images, User, Coins, LogOut } from 'lucide-react';
import { cn } from '@/lib/cn';
import { Button } from '@/components/ui/button';
import { useSession } from '@/lib/session';
import { useCredits } from '@/hooks/useCredits';
import { formatCredits } from '@/lib/format';

const nav = [
  { to: '/dashboard', label: 'Início', icon: Home },
  { to: '/upload', label: 'Renderizar', icon: Image },
  { to: '/renders', label: 'Meus renders', icon: Images },
  { to: '/creditos', label: 'Créditos', icon: Coins },
  { to: '/profile', label: 'Perfil', icon: User },
];

export const Sidebar = () => {
  const signOut = useSession((s) => s.signOut);
  const credits = useCredits();
  const navigate = useNavigate();

  return (
    <aside className="flex h-svh w-64 shrink-0 flex-col border-r border-sidebar-border bg-sidebar text-sidebar-foreground">
      <div className="flex items-center gap-2 border-b border-sidebar-border p-4">
        <img src="/logo.svg" alt="Pórtico" className="size-8" />
        <span className="text-lg font-display font-semibold">Pórtico</span>
      </div>

      <div className="flex items-center justify-between border-b border-sidebar-border px-4 py-3 text-sm">
        <span className="text-muted-foreground">Créditos</span>
        <span className="font-semibold text-sidebar-accent">
          {credits.isLoading ? '…' : formatCredits(credits.data ?? 0)}
        </span>
      </div>

      <nav className="flex-1 space-y-1 p-2">
        {nav.map(({ to, label, icon: Icon }) => (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) =>
              cn(
                'flex items-center gap-3 rounded-md px-3 py-2 text-sm transition-colors',
                'hover:bg-sidebar-accent/10 hover:text-sidebar-accent',
                isActive ? 'bg-sidebar-accent text-sidebar' : 'text-sidebar-foreground/80',
              )
            }
          >
            <Icon className="size-4" />
            {label}
          </NavLink>
        ))}
      </nav>

      <div className="border-t border-sidebar-border p-2">
        <Button
          variant="ghost"
          className="w-full justify-start text-sidebar-foreground/80 hover:bg-sidebar-accent/10"
          onClick={async () => {
            await signOut();
            navigate('/auth/login', { replace: true });
          }}
        >
          <LogOut className="size-4" /> Sair
        </Button>
      </div>
    </aside>
  );
};
